import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export function Card({
  children,
  className,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}): JSX.Element {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className={cn(
        'block w-full rounded-card border border-[var(--border-medium)] bg-tg-bg-secondary p-4 text-left',
        onClick && 'transition active:scale-[0.99]',
        className,
      )}
    >
      {children}
    </Tag>
  );
}

export function CardTitle({ children }: { children: ReactNode }): JSX.Element {
  return <h2 className="text-base font-semibold text-tg-text">{children}</h2>;
}

export function CardHint({ children }: { children: ReactNode }): JSX.Element {
  return <p className="text-sm text-tg-hint">{children}</p>;
}
